import { NgModule } from '@angular/core';
import { combineEffectsWithProviders } from '@essent/common';
import { ComposablesModule } from '@legacy/common-ui-common-renderings';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { UtilsEnvironmentModule } from '@innogy/utils/environment';
import { EffectsModule } from '@ngrx/effects';
import { combineReducers, StoreModule } from '@ngrx/store';

import { reviewsFeatureSelectorKey, reviewsReducers } from './+state';
import { getReviewsApi, getReviewStatisticsApi } from './+state/config';
import { ReviewEntryContainerComponent } from './review-entry/review-entry-container.component';
import { ReviewOverviewContainerComponent } from './review-overview/review-overview-container.component';
import { ReviewScoreContainerComponent } from './review-score/review-score-container/review-score-container.component';
import { ReviewScoreComponent } from './review-score/review-score.component';
import { ReviewSingleContainerComponent } from './review-single/review-single-container/review-single-container.component';
import { ReviewComponent } from './review-single/review.component';
import { ReviewStarsComponent } from './review-stars/review-stars.component';

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(
  getReviewsApi,
  getReviewStatisticsApi
);

const components = [
  ReviewScoreComponent,
  ReviewComponent,
  ReviewStarsComponent,
];

const exportComponents = [
  ReviewScoreContainerComponent,
  ReviewSingleContainerComponent,
  ReviewEntryContainerComponent,
  ReviewOverviewContainerComponent,
];

@NgModule({
  imports: [
    DefaultComponentModule,
    EffectsModule.forFeature(EFFECTS),
    StoreModule.forFeature(
      reviewsFeatureSelectorKey,
      combineReducers(reviewsReducers)
    ),
    ComposablesModule,
    UtilsEnvironmentModule,
  ],
  providers: [PROVIDERS],
  declarations: [...components, ...exportComponents],
  exports: exportComponents,
})
export class ReviewsModule {}
